import classNames from 'classnames';

import { ServicePlace } from 'src/constants';
import { useLocalization } from 'src/contexts/localization-context';
import { getLotDetails, getServicePlaceLabel } from 'src/utils';
import type { LotDetailsProps } from './lot-details.props';

import './lot-details.scss';

const LotDetails = ({ lot }: LotDetailsProps) => {
  const { getLocalization } = useLocalization();

  const renderFirstField = () => {
    const mausoleumName = lot.mausoleum?.name;
    return (
      <li className={classNames('lot-details__item', mausoleumName && 'lot-details__item_wide')}>
        <span className="lot-details__value">
          {getLocalization(
            getServicePlaceLabel(
              lot.type,
              mausoleumName ? ServicePlace.MAUSOLEUM : ServicePlace.SECTION
            )
          )}
          :
        </span>
        <span className="lot-details__value">{mausoleumName || lot.section}</span>
      </li>
    );
  };

  return (
    <ul className="lot-details">
      {renderFirstField()}

      {getLotDetails(lot)
        .filter((detail): detail is { label: string; field: string } => detail.field !== undefined)
        .map(({ field, label }) => (
          <li key={label} className="lot-details__item">
            <span className="lot-details__value">{getLocalization(label)}:</span>
            <span className="lot-details__value">{getLocalization(field)}</span>
          </li>
        ))}
    </ul>
  );
};

export default LotDetails;
